import { useState } from "react";
import { CheckCircle2, Bell, Search, Loader2, MessageSquare, ArrowUp, ArrowDown } from "lucide-react";
import { TrainingComplianceEntry } from "../../types/training";
import { sendNotificationForTrainingForMultiple, sendTeamsReminderForTraining } from "../../apicalls/trainingService";

const data = [
  {
    id: 1,
    name: "Alex Johnson",
    email: "alex.johnson@medforall.com",
    roles: ["DSP", "Team Lead"],
    training: "Basic Life Support",
    code: "BLS",
    status: "Expired",
    score: "95%",
    due: "Dec 14, 2024",
    client: null,
    badge: null,
    notified: true,
    selected: false,
    lastReminded: "Dec 16, 2024",
  },
  {
    id: 2,
    name: "Alex Johnson",
    email: "alex.johnson@medforall.com",
    roles: ["DSP", "Team Lead"],
    training: "Infection Control",
    code: "IC",
    status: "Not Completed",
    score: "-",
    due: "Jun 29, 2024",
    client: "Jordan W.",
    badge: "ISP",
    notified: true,
    selected: false,
    lastReminded: "Dec 16, 2024",
  },
  {
    id: 3,
    name: "Morgan Smith",
    email: "morgan.smith@medforall.com",
    roles: ["RSA", "Specialist"],
    training: "Advanced Cardiac Life Support",
    code: "ACLS",
    status: "Expired",
    score: "92%",
    due: "Jul 9, 2024",
    client: null,
    badge: null,
    notified: false,
    selected: false,
    lastReminded: "Dec 16, 2024",
  },
  {
    id: 4,
    name: "Taylor Williams",
    email: "taylor.williams@medforall.com",
    roles: ["DSP"],
    training: "Basic Life Support",
    code: "BLS",
    status: "Expired",
    score: "88%",
    due: "Apr 30, 2024",
    client: null,
    badge: null,
    notified: false,
    selected: false,
    lastReminded: "Dec 16, 2024",
  },
  {
    id: 5,
    name: "Jordan Brown",
    email: "jordan.brown@medforall.com",
    roles: ["QA Specialist"],
    training: "Radiation Safety",
    code: "RS",
    status: "Expired",
    score: "91%",
    due: "Nov 19, 2024",
    client: null,
    badge: null,
    notified: true,
    selected: false,
    lastReminded: "Dec 16, 2024",
  },
  {
    id: 6,
    name: "Casey Davis",
    email: "casey.davis@medforall.com",
    roles: ["Admin"],
    training: "HIPAA Compliance",
    code: "HIPAA",
    status: "Expired",
    score: "-",
    due: "Jun 14, 2024",
    client: null,
    badge: null,
    notified: true,
    selected: false,
    lastReminded: "Dec 16, 2024",
  },
  {
    id: 7,
    name: "Riley Wilson",
    email: "riley.wilson@medforall.com",
    roles: ["DSP", "Educator"],
    training: "Chemotherapy Administration",
    code: "CA",
    status: "Expired",
    score: "97%",
    due: "Aug 4, 2024",
    client: null,
    badge: null,
    notified: false,
    selected: false,
    lastReminded: "Dec 16, 2024",
  },
  {
    id: 8,
    name: "Jamie Garcia",
    email: "jamie.garcia@medforall.com",
    roles: ["Department Director"],
    training: "Neurological Assessment",
    code: "NA",
    status: "Expired",
    score: "65%",
    due: "May 24, 2024",
    client: null,
    badge: null,
    notified: true,
    selected: false,
    lastReminded: "Dec 16, 2024",
  },
  {
    id: 9,
    name: "Quinn Martinez",
    email: "quinn.martinez@medforall.com",
    roles: ["Client-Services Specialist"],
    training: "Medication Management",
    code: "MM",
    status: "Expired",
    score: "94%",
    due: "Oct 9, 2024",
    client: "Riley K.",
    badge: "ISP",
    notified: true,
    selected: false,
    lastReminded: "Dec 16, 2024",
  },
  {
    id: 10,
    name: "Avery Robinson",
    email: "avery.robinson@medforall.com",
    roles: ["QA Intern", "Specialist"],
    training: "Laboratory Safety",
    code: "LS",
    status: "Expired",
    score: "-",
    due: "Jun 19, 2024",
    client: null,
    badge: null,
    notified: true,
    selected: false,
    lastReminded: "Dec 16, 2024",
  },
  {
    id: 11,
    name: "Avery Robinson",
    email: "avery.robinson@medforall.com",
    roles: ["QA Intern", "Specialist"],
    training: "Laboratory Safety",
    code: "LS",
    status: "Expired",
    score: "-",
    due: "Jun 19, 2024",
    client: null,
    badge: null,
    notified: true,
    selected: false,
    lastReminded: "Dec 16, 2024",
  },
];

const PAGE_SIZE = 50;

export default function EmployeeTrainingTable({ complianceData }: { complianceData: TrainingComplianceEntry[] }) {
  const [showReminded, setShowReminded] = useState(false);
  const [search, setSearch] = useState("");
  const [page, setPage] = useState(1);

  const [selectAll, setSelectAll] = useState(false);

  const [notificationLoading, setNotificationLoading] = useState(false);
  const [notificationSent, setNotificationSent] = useState(false);

  const [teamsReminderLoading, setTeamsReminderLoading] = useState(false);
  const [teamsReminderSent, setTeamsReminderSent] = useState(false);

  const [searchTerm, setSearchTerm] = useState("");
  const [sortConfig, setSortConfig] = useState<{
    key: 'name' | null;
    direction: 'asc' | 'desc';
  }>({
    key: null,
    direction: 'asc'
  });

  const [filteredData, setFilteredData] = useState(complianceData);

  const handleSelectAll = () => {
    
    complianceData.forEach(row => {
      row.selected = !selectAll;
    });
    setSelectAll(!selectAll);
    setFiltered(complianceData.filter(
        (row) =>
          row.name.toLowerCase().includes(search.toLowerCase()) ||
          row.email.toLowerCase().includes(search.toLowerCase()) ||
          row.training.toLowerCase().includes(search.toLowerCase())
      ));
    setPaginated(filtered.slice((page - 1) * PAGE_SIZE, page * PAGE_SIZE));
  };

  const handleSelect = (row) => {
    if (selectAll && row.selected) {
        setSelectAll(false);
    }

    setFiltered(filtered.map(r => ({ ...r, selected: r.employeeID === row.employeeID ? !r.selected : r.selected })));
    setPaginated(paginated.map(r => ({ ...r, selected: r.employeeID === row.employeeID ? !r.selected : r.selected })));
  };

  const [filtered, setFiltered] = useState(complianceData.filter(
    (row) =>
      row.name.toLowerCase().includes(search.toLowerCase()) ||
      row.email.toLowerCase().includes(search.toLowerCase()) ||
      row.training.toLowerCase().includes(search.toLowerCase())
  ));

  const [paginated, setPaginated] = useState(filtered.slice((page - 1) * PAGE_SIZE, page * PAGE_SIZE));

  const handleSendNotifications = async () => {
    setNotificationLoading(true);
    setNotificationSent(false);
    // Get Selected Compliance Entries
    const selectedComplianceEntries = paginated.filter(row => row.selected);

    console.log(selectedComplianceEntries);
    // Send Notifications
    await sendNotificationForTrainingForMultiple(selectedComplianceEntries, (error) => {
      console.error(error);
    });
    // Simulate async notification sending
    //await new Promise(res => setTimeout(res, 1500));
    setNotificationLoading(false);
    setNotificationSent(true);
    setTimeout(() => setNotificationSent(false), 1500);
  };

  const handleSendTeamsReminder = async () => {
    setTeamsReminderLoading(true);

    // Get Selected Compliance Entries
    const selectedComplianceEntries = paginated.filter(row => row.selected);

    // Send Teams Reminders
    await sendTeamsReminderForTraining(selectedComplianceEntries);
    setTeamsReminderLoading(false);
    setTeamsReminderSent(true);
    setTimeout(() => setTeamsReminderSent(false), 1500);
  };

  const handleSort = (key: 'name') => {
    let direction: 'asc' | 'desc' = 'asc';
    if (sortConfig.key === key && sortConfig.direction === 'asc') {
      direction = 'desc';
    }
    setSortConfig({ key, direction });

    const sortedData = [...filteredData].sort((a, b) => {
      const aValue = a[key] || '';
      const bValue = b[key] || '';
      if (direction === 'asc') {
        return aValue.localeCompare(bValue);
      }
      return bValue.localeCompare(aValue);
    });
    setFilteredData(sortedData);
    setPaginated(sortedData.slice((page - 1) * PAGE_SIZE, page * PAGE_SIZE));
  };

  const getSortIcon = (key: 'name') => {
    if (sortConfig.key !== key) return null;
    return sortConfig.direction === 'asc' ? 
      <ArrowUp className="tw-w-4 tw-h-4 tw-inline-block tw-ml-1" /> : 
      <ArrowDown className="tw-w-4 tw-h-4 tw-inline-block tw-ml-1" />;
  };

  return (
    <div className="tw-bg-white tw-rounded-2xl tw-shadow tw-p-6 tw-w-full">
      <div className="tw-flex tw-items-center tw-justify-between tw-mb-4">
        <div className="tw-text-gray-500 tw-text-sm">
          {filtered.length} records found
        </div>
        <div className="tw-flex tw-items-center tw-gap-4">
          <label className="tw-flex tw-items-center tw-gap-2 tw-text-gray-700 tw-text-sm">
            <input
              type="checkbox"
              className="tw-form-checkbox tw-border-gray-300"
              checked={showReminded}
              onChange={() => setShowReminded((v) => !v)}
            />
            Show Last Reminded
          </label>
          
          <div className="tw-flex tw-gap-2">
            <button
              className="tw-flex tw-items-center tw-gap-2 tw-bg-cyan-50 tw-text-cyan-700 tw-px-3 tw-py-1.5 tw-rounded-lg tw-border tw-border-cyan-200 tw-text-sm tw-font-medium hover:tw-bg-cyan-100 tw-relative tw-min-w-[140px]"
              onClick={handleSendNotifications}
              disabled={notificationLoading}
            >
              {notificationLoading ? (
                <Loader2 className="tw-w-4 tw-h-4 tw-animate-spin" />
              ) : notificationSent ? (
                <CheckCircle2 className="tw-w-4 tw-h-4 tw-text-green-500 tw-animate-fade-in-out" />
              ) : (
                <Bell className="tw-w-4 tw-h-4" />
              )}
              <span>{notificationSent ? "Sent!" : "Send Notifications"}</span>
            </button>

            <button
              className="tw-flex tw-items-center tw-gap-2 tw-bg-purple-50 tw-text-purple-700 tw-px-3 tw-py-1.5 tw-rounded-lg tw-border tw-border-purple-200 tw-text-sm tw-font-medium hover:tw-bg-purple-100 tw-relative tw-min-w-[140px]"
              onClick={handleSendTeamsReminder}
              disabled={teamsReminderLoading}
            >
              {teamsReminderLoading ? (
                <Loader2 className="tw-w-4 tw-h-4 tw-animate-spin" />
              ) : teamsReminderSent ? (
                <CheckCircle2 className="tw-w-4 tw-h-4 tw-text-green-500 tw-animate-fade-in-out" />
              ) : (
                <MessageSquare className="tw-w-4 tw-h-4" />
              )}
              <span>{teamsReminderSent ? "Sent!" : "Send Teams Reminder"}</span>
            </button>
          </div>
        </div>
      </div>
      <div className="tw-relative tw-mb-4">
        <span className="tw-absolute tw-left-3 tw-top-2.5 tw-text-gray-400">
          <Search className="tw-w-4 tw-h-4" />
        </span>
        <input
          className="tw-w-full tw-pl-10 tw-pr-3 tw-py-2 tw-border tw-border-gray-200 tw-rounded-md tw-text-sm"
          placeholder="Search employees or certificates"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />
      </div>
      <div className="tw-overflow-x-auto">
        <table className="tw-w-full tw-text-sm tw-text-left">
          <thead>
            <tr className="tw-bg-gray-50">
              <th className="tw-px-2 tw-py-2">
                <input type="checkbox" className="tw-form-checkbox tw-border-gray-300 tw-cursor-pointer" checked={selectAll} onChange={handleSelectAll} />
              </th>
              <th 
                className="tw-px-2 tw-py-2 tw-cursor-pointer hover:tw-bg-gray-100"
                onClick={() => handleSort('name')}
              >
                <div className="tw-flex tw-items-center tw-justify-between">
                  Employee
                  {getSortIcon('name')}
                </div>
              </th>
              <th className="tw-px-2 tw-py-2">Roles</th>
              <th className="tw-px-2 tw-py-2">Training/Certificate</th>
              <th className="tw-px-2 tw-py-2">Status</th>
              <th className="tw-px-2 tw-py-2">Score</th>
              <th className="tw-px-2 tw-py-2">Due Date</th>
              {showReminded && <th className="tw-px-2 tw-py-2">Last Reminded</th>}
              <th className="tw-px-2 tw-py-2"></th>
            </tr>
          </thead>
          <tbody>
            {paginated.map((row) => (
              <tr key={row.employeeID} className="tw-border-b tw-border-gray-100 hover:tw-bg-gray-50">
                <td className="tw-px-2 tw-py-2">
                  <input type="checkbox" className="tw-form-checkbox tw-cursor-pointer tw-border-gray-300" checked={row.selected} onChange={() => handleSelect(row)} />
                </td>
                <td className="tw-px-2 tw-py-2">
                  <div className="tw-font-semibold tw-text-gray-900">{row.name}</div>
                  <div className="tw-text-xs tw-text-gray-500">{row.email}</div>
                </td>
                <td className="tw-px-2 tw-py-2">
                  <div className="tw-flex tw-flex-wrap tw-gap-1">
                    {row.roles.map((role) => (
                      <span
                        key={role}
                        className="tw-bg-gray-100 tw-text-gray-700 tw-px-2 tw-py-0.5 tw-rounded tw-text-xs tw-font-medium"
                      >
                        {role}
                      </span>
                    ))}
                  </div>
                </td>
                <td className="tw-px-2 tw-py-2">
                  <div className="tw-flex tw-items-center tw-gap-2">
                    {row.badge && (
                      <span className="tw-bg-cyan-100 tw-text-cyan-700 tw-px-2 tw-py-0.5 tw-rounded tw-text-xs tw-font-semibold">
                        {row.badge}
                      </span>
                    )}
                    <span className="tw-font-medium tw-text-gray-900">{row.training}</span>
                  </div>
                  <div className="tw-text-xs tw-text-gray-500">
                    Code: {row.code}
                    {row.client && (
                      <span className="tw-ml-2">Client: {row.client}</span>
                    )}
                  </div>
                </td>
                <td className="tw-px-2 tw-py-2">
                  <span className="tw-bg-red-100 tw-text-red-700 tw-px-2 tw-py-0.5 tw-rounded tw-text-xs tw-font-semibold">
                    {row.status}
                  </span>
                </td>
                <td className="tw-px-2 tw-py-2">{row.score}</td>
                <td className="tw-px-2 tw-py-2">{row.due}</td>
                {showReminded && <td className="tw-px-2 tw-py-2">{row.lastReminded}</td>}
                <td className="tw-px-2 tw-py-2">
                  {row.notified ? (
                    <CheckCircle2 className="tw-w-5 tw-h-5 tw-text-cyan-500" />
                  ) : (
                    <span className="tw-inline-block tw-w-5 tw-h-5"></span>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      {/* Pagination */}
      <div className="tw-flex tw-items-center tw-justify-between tw-mt-2 tw-text-xs tw-text-gray-500">
        <span>
          Showing {Math.min((page - 1) * PAGE_SIZE + 1, filtered.length)}-
          {Math.min(page * PAGE_SIZE, filtered.length)} of {filtered.length} entries
        </span>
        <div className="tw-flex tw-gap-1">
          <button
            className="tw-px-2 tw-py-1 tw-rounded tw-border tw-border-gray-200 tw-bg-white tw-text-gray-700 disabled:tw-opacity-50"
            disabled={page === 1}
            onClick={() => setPage((p) => Math.max(1, p - 1))}
          >
            {"<"}
          </button>
          {Array.from({ length: Math.ceil(filtered.length / PAGE_SIZE) }, (_, i) => (
            <button
              key={i + 1}
              className={`tw-px-2 tw-py-1 tw-rounded tw-border tw-border-gray-200 tw-bg-white tw-text-gray-700 ${
                page === i + 1 ? "tw-bg-gray-100 tw-font-bold" : ""
              }`}
              onClick={() => setPage(i + 1)}
            >
              {i + 1}
            </button>
          ))}
          <button
            className="tw-px-2 tw-py-1 tw-rounded tw-border tw-border-gray-200 tw-bg-white tw-text-gray-700 disabled:tw-opacity-50"
            disabled={page === Math.ceil(filtered.length / PAGE_SIZE) || Math.ceil(filtered.length / PAGE_SIZE) === 0}
            onClick={() => setPage((p) => Math.min(Math.ceil(filtered.length / PAGE_SIZE), p + 1))}
          >
            {">"}
          </button>
        </div>
      </div>
    </div>
  );
}